"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var calendar_1 = require("./services/calendar");
exports.create = calendar_1.create;
exports.default = angular.module('AdageCalendar', [])
    .factory('calendarService', calendar_1.default)
    .name;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/calendar/index.js
// module id = 379
// module chunks = 0